<template>
  <section class="section">
    <div class="container">
      <div
        class="column is-8-tablet is-offset-2-tablet is-4-desktop is-offset-4-desktop"
      >
        <h1 class="title">Change Password</h1>

        <form
          class="form has-placeholders"
          @submit.prevent="validateBeforeSubmit"
        >
          <fieldset>
            <label class="input -spacing-static-c">
              <mask-password-toggle></mask-password-toggle>
              <input
                :class="{
                  input__field: true,
                  error: errors.has('currentPassword')
                }"
                name="currentPassword"
                type="password"
                placeholder="Verify Current Password"
                v-model="currentPassword"
                v-validate="'required|min:10|verify_password'"
              />
              <span class="input__label">Verify Current Password</span>
            </label>

            <label class="input -spacing-static-c">
              <mask-password-toggle></mask-password-toggle>
              <input
                :class="{
                  input__field: true,
                  error: errors.has('newPassword')
                }"
                name="newPassword"
                @input="checkPassword($event)"
                type="password"
                ref="password"
                placeholder="New Password"
                v-model="newPassword"
                v-validate="'required|min:10|verify_password'"
                data-vv-validate-on="input|blur"
              />
              <span class="input__label">New Password</span>
            </label>

            <label class="input -spacing-static-c">
              <mask-password-toggle></mask-password-toggle>
              <input
                :class="{
                  input__field: true,
                  error: errors.has('confirmNewPassword')
                }"
                @input="checkPassword($event)"
                name="confirmNewPassword"
                type="password"
                placeholder="Confirm New Password"
                v-model="confirmNewPassword"
                v-validate="'required|confirmed:password'"
                data-vv-validate-on="input|blur"
              />
              <span class="input__label">Confirm New Password</span>
            </label>

            <ul class="password-requirements -spacing-b">
              <li :class="{ 'has-passed': hasMinimum }">
                <span
                  class="icon"
                  :class="[hasMinimum ? 'icon--check' : 'icon--close']"
                ></span
                >Minimum length 10 characters
              </li>
              <li :class="{ 'has-passed': hasNumber }">
                <span
                  class="icon"
                  :class="[hasNumber ? 'icon--check' : 'icon--close']"
                ></span
                >Number
              </li>
              <li :class="{ 'has-passed': hasUppercase }">
                <span
                  class="icon"
                  :class="[hasUppercase ? 'icon--check' : 'icon--close']"
                ></span
                >Upper-case letter
              </li>
              <li :class="{ 'has-passed': hasLowercase }">
                <span
                  class="icon"
                  :class="[hasLowercase ? 'icon--check' : 'icon--close']"
                ></span
                >Lower-case letter
              </li>
              <li :class="{ 'has-passed': hasSpecial }">
                <span
                  class="icon"
                  :class="[hasSpecial ? 'icon--check' : 'icon--close']"
                ></span
                >Special characters
              </li>
              <li :class="{ 'has-passed': passwordsMatch }">
                <span
                  class="icon"
                  :class="[passwordsMatch ? 'icon--check' : 'icon--close']"
                ></span
                >Passwords match
              </li>
            </ul>

            <button
              class="button-primary  button-primary--black button-primary--stretch -spacing-static-f"
              type="submit"
            >
              <span class="button-primary__icon icon icon--arrow-right-hair">
                <span class="loader-base button-primary__loader"></span>
              </span>
              <span class="button-primary__label">Update</span>
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import MaskPasswordToggle from '../../components/shared/MaskPasswordToggle';

export default {
  name: 'ChangePassword',
  components: {
    MaskPasswordToggle
  },
  data: () => ({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    hasMinimum: false,
    hasNumber: false,
    hasUppercase: false,
    hasLowercase: false,
    hasSpecial: false,
    passwordsMatch: false
  }),
  methods: {
    ...mapActions(['changePassword']),
    validateBeforeSubmit() {
      let firstErrorField;
      let payload = {
        newPassword: this.newPassword,
        oldPassword: this.currentPassword
      };
      this.$validator.validateAll().then(result => {
        if (result) {
          this.changePassword(payload)
            .then(() => {
              this.showSnackBar({
                type: 'is-success',
                message: 'Successfully updated the Password!',
                position: 'is-bottom'
              });
              this.$router.push('/');
            })
            .catch(() => {
              this.showSnackBar({
                type: 'is-danger',
                message: '',
                position: 'is-bottom'
              });
              let message = document.querySelector('.snackbar > .text');
              message.innerHTML = `The system is unable to complete your request at this time. 
              Please call <nobr><a style="text-decoration:underline;color:#fff" href="tel:1-800-400-4128">800-400-4128</a></nobr> 
              to speak to a customer service concierge.`;
            });
          return;
        }

        firstErrorField = this.$el.querySelector(
          '[name="' + this.$validator.errors.items[0].field + '"]'
        );
        firstErrorField.scrollIntoView(false);
        firstErrorField.focus();
      });
    },
    checkPassword: function(e) {
      let val = e.target.value,
        confirmNewPassword = document.querySelector(
          'input[name="confirmNewPassword"]'
        ).value;

      if (val.length >= 10) {
        this.hasMinimum = true;
      } else {
        this.hasMinimum = false;
      }

      this.hasNumber = /\d/.test(val);
      this.hasUppercase = /[A-Z]/.test(val);
      this.hasLowercase = /[a-z]/.test(val);
      this.hasSpecial = /[!@#$%^&*)(+=._-]/.test(val);

      if (this.newPassword === confirmNewPassword && this.newPassword !== '') {
        this.passwordsMatch = true;
      } else {
        this.passwordsMatch = false;
      }
    },
    showSnackBar(options) {
      this.$snackbar.open(options);
    }
  }
};
</script>
<style lang="scss" scoped>
.password-requirements {
  color: $jumbo;
  font-size: 14px;
  list-style-type: none;
  padding-left: 0;

  li {
    padding-left: 20px;
    position: relative;

    &.has-passed {
      color: green;
    }
  }

  .icon {
    position: absolute;
    top: 4px;
    left: 0;
  }
}
</style>
